export const baseApiUrl = "https://hraveturnaje.cz/api/pinec"
export const baseApiUrlLocal = "http://localhost:8090/api/pinec"
export const publicApiUrl = baseApiUrl + "/public"
export const adminApiUrl = baseApiUrl + "/admin"
export const superAdminApiUrl = baseApiUrl + "/superadmin"
export const signedInApiUrl = baseApiUrl + "/auth"

export const LANGUAGES = [
  { label: "Czech", code: "cs" },
  { label: "English", code: "en" },
];

// `as const` narrows values to string literals (not generic string),
// enabling exhaustive checks downstream and stronger autocomplete.
export const MATCH_RESULTS = {
  IN_PROGRESS: "IN_PROGRESS",
  PLAYER_ONE_WON: "PLAYER_ONE_WON",
  PLAYER_TWO_WON: "PLAYER_TWO_WON",
  PLAYER_ONE_DEFAULT: "PLAYER_ONE_DEFAULT",
  PLAYER_TWO_DEFAULT: "PLAYER_TWO_DEFAULT",
  CANCELED: "CANCELED",
} as const;
export type MatchResult = typeof MATCH_RESULTS[keyof typeof MATCH_RESULTS];

export const ROUND_STATES = {
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  CANCELED: "CANCELED",
} as const;
export type RoundState = typeof ROUND_STATES[keyof typeof ROUND_STATES];

export const TOURNAMENT_STATES = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  CANCELED: "CANCELED",
} as const;
export type TournamentState = typeof TOURNAMENT_STATES[keyof typeof TOURNAMENT_STATES];

export const FREE_WIN_PLAYER_ID = 1 as const;

export const ACHIEVEMENT_IMAGES = {
  GOLD: "/icons/gold-medal.png",
  SILVER: "/icons/silver-medal.png",
  BRONZE: "/icons/bronze-medal.png",
  POTATO: "/icons/potato.png",
  HAT_TRICK: "/icons/three-stars-2.png",
  UNDEFEATED: "/icons/crown.png",
  UNSTOPPABLE: "/icons/bomb.png",
  DISHONORED: "/icons/dishonored.png",
  PLOT_TWIST: "/icons/shock.png",
  PROPHECY: "/icons/moses.png",
  HARDEST_PATH: "/icons/doom-guy.png",
  NO_HURRY: "/icons/where-is-my-towel.png",
  TIME_IS_MONEY: "/icons/i-need-to-go.png",
  GET_YOUR_MONEYS_WORTH: "/icons/take-my-money.png",
  ALL_THINGS_MUST_BE_BALANCED: "/icons/thanos.png",
  PEAK_PERFORMANCE: "/icons/peak-performance.png",
  CONSISTENCY_IS_KEY: "/icons/key-to-success.png",
  BACK_FROM_THE_DEAD: "/icons/back-from-the-dead.png",
  FLASH: "/icons/the-flash.jpeg",
  SLOWPOKE: "/icons/slowpoke.png",
}
